import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import axios from "axios";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function PaymentOptions({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [subscription, setSubscription] = useState([]);

  const [payAsGo, setPayAsGo] = useState([]);
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  let ConvertToCurrency = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  });

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const prodResponse = await axios.get(
        `${ApiConnectionString}/api/myproducts?ClubId=${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      // Filtering out data with "recurring" set to true
      const filterSub = prodResponse.data.filter(
        (product) => product.recurring === true
      );
      setSubscription(filterSub);

      // Filtering out data with "recurring" set to false
      const filterPayAsGo = prodResponse.data.filter(
        (product) => product.recurring === false
      );
      setPayAsGo(filterPayAsGo);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      // Handle errors here
      console.error("Error fetching products:", error);
      // Optionally, you could set an error state or notify the user
    } finally {
      // Always set loading to false after fetching data
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [id, user]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else{
  return (
    <div className="container bg-white p-3 p-md-4 rounded-3 shadow-sm">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <p className="fw-bold h4 mb-0">Payment Options</p>
        <Link to={`/createproduct/${id}`} className="btn btn-primary">
          Add Payment Option
        </Link>
      </div>

      {subscription.length === 0 && payAsGo.length === 0 && (
        <p className="text-muted mb-4">
          No payment options yet. Use the button above to add one.
        </p>
      )}

      <div className="mb-4">
        <p className="lead mb-2 fw-bold red-text">Subscription Options</p>

        {subscription.length > 0 ? (
          <div className="list-group">
            {subscription.map((prod) => (
              <button
                type="button"
                key={prod.id}
                className="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                onClick={() => navi(`/myoneproduct/${prod.id}`)}
              >
                <div className="me-3">
                  <div className="fw-semibold">{prod.name}</div>
                  <div className="mt-1">
                    <span className="badge rounded-pill text-bg-light border me-2">
                      {prod.interval}
                    </span>
                    {prod.default && (
                      <span className="badge rounded-pill text-bg-primary">
                        Default
                      </span>
                    )}
                  </div>
                </div>
                <div className="fw-bold">
                  {ConvertToCurrency.format(prod.price / 100)}
                </div>
              </button>
            ))}
          </div>
        ) : (
          <p className="text-muted">No subscription products found</p>
        )}
      </div>

      <div>
        <p className="lead mb-2 fw-bold red-text">Flexible Class Pack options</p>

        {payAsGo.length > 0 ? (
          <div className="list-group">
            {payAsGo.map((prod) => (
              <button
                type="button"
                key={prod.id}
                className="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                onClick={() => navi(`/myoneproduct/${prod.id}`)}
              >
                <div className="me-3">
                  <div className="fw-semibold">{prod.name}</div>
                  <div className="mt-1">
                    <span className="badge rounded-pill text-bg-light border">
                      {prod.token} classes
                    </span>
                  </div>
                </div>
                <div className="fw-bold">
                  {ConvertToCurrency.format(prod.price / 100)}
                </div>
              </button>
            ))}
          </div>
        ) : (
          <p className="text-muted">No Flexible Class Pack products found</p>
        )}
      </div>
    </div>
  );
}

}
